<div class="tab-box">
    <div class="title-ind">
      <h1 class="title-tab">Facturas</h1>
    </div>
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
      <ng-container matColumnDef="nº factura">
        <th color="primary" mat-header-cell *matHeaderCellDef mat-sort-header>
          Nº FACTURA
        </th>
        <td mat-cell *matCellDef="let factura">{{factura.numeroFactura}}</td>
      </ng-container>
      <ng-container matColumnDef="concepto">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>CONCEPTO</th>
        <td mat-cell *matCellDef="let factura">{{factura.concepto}}</td>
      </ng-container>
      <ng-container matColumnDef="total">
        <th color="primary" mat-header-cell *matHeaderCellDef mat-sort-header>
          IMPORTE TOTAL
        </th>
        <td mat-cell *matCellDef="let factura">{{factura.precioTotal}} €</td>
      </ng-container>
      <ng-container matColumnDef="fecha pago">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>FECHA PAGO</th>
        <td mat-cell *matCellDef="let factura">{{factura.fechaConfirmacion | date: 'dd/MM/YYY'}}</td>
      </ng-container>
      <ng-container matColumnDef="descargar">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>DESCARGAR</th>
        <td mat-cell *matCellDef="let factura"><img src="./../../../../assets/descargar.png" alt="" (click)="generatePdf(factura.numeroFactura,factura.fechaConfirmacion,factura.numeroLicencias, factura.concepto, factura.precioUnitario,factura.baseImponible, factura.iva, factura.formaPago, factura.precioTotal )"></td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: tableColumns"></tr>
    </table>
    <mat-paginator [pageSizeOptions]="[10, 15, 20]"></mat-paginator>
  </div>

